import { render, staticRenderFns } from "./CrmClients.vue?vue&type=template&id=99421e20&scoped=true"
import script from "./CrmClients.vue?vue&type=script&lang=js"
export * from "./CrmClients.vue?vue&type=script&lang=js"
import style0 from "./CrmClients.vue?vue&type=style&index=0&id=99421e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99421e20",
  null
  
)

export default component.exports